import {COLORS} from 'frontend/utils/color_palettes';
import {openedSwitchSVG} from 'frontend/utils/icons';

import {AssetMapMarkerData, DefaultMapMarker, IconSize} from './default';

const DISCONNECTOR_COLOR = COLORS.NewPrimary.get(40);

export interface DisconnectorMapMarkerData extends AssetMapMarkerData {
  color?: string;
}

/**
 * A map marker for a disconnector asset.
 */
export class DisconnectorMapMarker extends DefaultMapMarker<DisconnectorMapMarkerData> {
  protected override getDefaultIcon(size: IconSize): string {
    return openedSwitchSVG(this.data?.color ?? DISCONNECTOR_COLOR, size);
  }
}
